import React from "react";
import SEO from "../components/SEO";
const Terms = () => (
  <>
    <SEO title="Terms & Conditions" />
    <section className="max-w-3xl mx-auto px-6 py-16 text-white/80 leading-relaxed">
      <p className="font-mono-cap text-[10px] text-white/40">Legal</p>
      <h1 className="font-serif text-5xl mt-2 text-white">Terms & Conditions.</h1>
      <div className="mt-8 space-y-5 text-sm">
        <p><b className="text-white">Purchase terms:</b> by placing an order you confirm the information provided is accurate and you authorise us to ship to that address.</p>
        <p><b className="text-white">Payment:</b> orders are confirmed only on receipt of full UPI payment or successful COD verification call.</p>
        <p><b className="text-white">Pricing:</b> all prices are in INR and inclusive of GST where applicable. Prices may change without notice.</p>
        <p><b className="text-white">Intellectual property:</b> all graphics, prints, designs, photographs, and the brand name "The Dripchexk" are the exclusive property of the brand. Reproduction in any form is prohibited.</p>
        <p><b className="text-white">Limitation of liability:</b> our maximum liability for any order is limited to the order value.</p>
        <p><b className="text-white">Governing law:</b> these terms are governed by the laws of India. All disputes are subject to the exclusive jurisdiction of the courts in New Delhi, India.</p>
      </div>
    </section>
  </>
);
export default Terms;
